@if (!isDismissed) {
<div
  class="push-notification"
  data-cy="add-home-screen-banner"
  [class.main-head-notification]="notificationData?.style === 'promotional'"
  [style.background]="notificationData?.style === 'promotional' ? notificationData?.background : null"
>
  <div class="notification-header">
    <div class="header">
      <div class="bell-wrapper">
        <img [src]="getIconUrl(notificationData?.icon_url)" alt="Home screen icon" />
      </div>
      <p [innerHTML]="notificationData?.content?.title || ('safari-add-home-screen.title' | translate)"></p>
    </div>
    <button
      type="button"
      class="close-notify"
      data-cy="add-home-screen-dismiss"
      (click)="dismissNotification()"
      [attr.aria-label]="'add-home-screen.close' | translate"
    >
      <img
        [src]="'../../../assets/icon/' + (notificationData?.style === 'promotional' ? 'close-circle.svg' : 'close-gray.svg')"
        alt=""
      />
    </button>
  </div>
  <div class="notify-content">
    <div>
      <p
        class="content-title"
        [innerHTML]="notificationData?.content?.line_1 || ('safari-add-home-screen.intro' | translate)"
      ></p>
      <p
        class="content-subtitle"
        [innerHTML]="notificationData?.content?.line_2 || ''"
      ></p>
    </div>
    <button
      class="active-btn"
      type="button"
      data-cy="add-home-screen-cta"
      (click)="openSafariSteps()"
    >
      {{
        notificationData?.content?.button_label ||
          ("safari-add-home-screen.show_how" | translate)
      }}
    </button>
  </div>
</div>
}
